import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notificationList: [],
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotifications: (state, action) => {
      const { title, descriptions } = action?.payload;
      state.notificationList = [
        { title, descriptions, id: Date.now() },
        ...state?.notificationList,
      ];
    },
    clearAllNotifications: (state, action) => {
      state.notificationList = [];
    },
    clearNotificationById: (state, action) => {
      const { id } = action?.payload;
      let newList = state?.notificationList?.filter(item => item?.id !== id);
      state.notificationList = newList;
    },
  },
});

export const {
  setNotifications,
  clearAllNotifications,
  clearNotificationById,
} = notificationSlice?.actions;
export default notificationSlice?.reducer;
